import { useCallback, useContext, useEffect, useState } from "react";
import { ContextStatus } from "@leedpulse-monorepo/enums";
import getVoipEnabledUsers from "../../../domain/use_cases/leedflow/voipCalls/getVoipEnabledUsers";
import UserDoc from "../../../domain/models/UserDoc";
import AuthenticationContext from "../../contexts/auth/AuthenticationContext";

export const useVoipEnabledUsers = () => {
    const authContext = useContext(AuthenticationContext);
    const auth = authContext.authentication;

    const [users, setUsers] = useState<UserDoc[]>([]);
    const [status, setStatus] = useState<ContextStatus>(ContextStatus.IDLE);

    const load = useCallback(async () => {
        if (!auth) return;
        setStatus(ContextStatus.LOADING);
        try {
            const res = await getVoipEnabledUsers();
            setUsers(res);
            setStatus(ContextStatus.SUCCESS);
        } catch (error) {
            console.error(error);
            setStatus(ContextStatus.ERROR);
        }
    }, [auth]);

    useEffect(() => {
        // Synchro avec un contexte qui fetche : l'etat local suit le resultat d'un
        // chargement declenche ici. Architecture Context + use case du repo.
        // eslint-disable-next-line react/set-state-in-effect
        load();
    }, [load]);

    return { users, status, reload: load };
};
